import React, { useState } from 'react';
import BookingBaggageFeesModal from './BookingBaggageFeesModal';

export function BaggageSuitcaseIcon() {
  return (
    <svg className="booking-flight-icon booking-flight-icon--bag" viewBox="0 0 10 15" width={10} height={15} aria-hidden>
      <path
        fill="currentColor"
        d="M7.121 3.994H2.902V1.198c0-.22.188-.4.419-.4h3.382c.23 0 .418.18.418.4zm1.806 0h-.969V1.199C7.958.538 7.395 0 6.703 0H3.321c-.692 0-1.256.538-1.256 1.198v2.796h-.969C.491 3.994 0 4.463 0 5.041v7.9c0 .578.491 1.046 1.096 1.046h.147v.76c0 .14.12.253.265.253h1.254a.26.26 0 0 0 .265-.253v-.76h3.97v.76c0 .14.119.253.265.253h1.253a.26.26 0 0 0 .265-.253v-.76h.147c.606 0 1.097-.468 1.097-1.046v-7.9c0-.578-.491-1.046-1.097-1.046z"
      />
    </svg>
  );
}

export function EntertainmentIcon() {
  return (
    <svg className="booking-flight-icon" viewBox="0 0 12 12" width={12} height={12} aria-hidden>
      <path
        fill="currentColor"
        d="M10.185 7.33h-8.37V2.107h8.37zM12 1.17a.874.874 0 0 0-.872-.872H.872A.874.874 0 0 0 0 1.17V8.892a.765.765 0 0 0 .767.738H4.66c-.007.171-.103.955-1.274 1.102h.037a.336.336 0 0 0 0 .671H8.55a.336.336 0 0 0 0-.67h.057C7.438 10.584 7.34 9.8 7.333 9.63h3.893a.767.767 0 0 0 .767-.738V1.17z"
      />
    </svg>
  );
}

export function InternetIcon() {
  return (
    <svg className="booking-flight-icon" viewBox="0 0 14 11" width={14} height={11} aria-hidden>
      <path
        fill="currentColor"
        d="M.276 4.585a.955.955 0 0 1-.005-1.338l.614-.623c.016-.016.034-.026.05-.041a8.814 8.814 0 0 1 12.026-.281.946.946 0 0 1 .152.123l.268.274c.003 0 .003.002.005.003l.34.345a.957.957 0 0 1-.003 1.34.927.927 0 0 1-1.321.003l-.483-.49a6.961 6.961 0 0 0-9.71.068l-.613.62a.917.917 0 0 1-.656.276.931.931 0 0 1-.664-.279zm2.577 2.479a1.056 1.056 0 0 1-.003-1.47l.325-.331.235-.24a5.217 5.217 0 0 1 7.315-.176c.015.012.029.022.04.034l.073.07.075.071.392.414c.19.193.294.452.294.726-.001.275-.106.534-.297.728a.994.994 0 0 1-1.426.004l-.405-.401a3.224 3.224 0 0 0-4.62.001l-.56.572a1 1 0 0 1-1.438-.002zm2.522 1.882a1.657 1.657 0 1 1 3.313-.002 1.657 1.657 0 0 1-3.314.002z"
      />
    </svg>
  );
}

/** Fork and knife — meal column on booking flight segments. */
export function MealIcon() {
  return (
    <svg
      className="booking-flight-icon booking-flight-icon--meal"
      viewBox="0 0 16 16"
      width={14}
      height={14}
      aria-hidden
    >
      <rect x="2" y="1" width="1" height="5.25" rx="0.2" fill="currentColor" />
      <rect x="3.5" y="1" width="1" height="5.25" rx="0.2" fill="currentColor" />
      <rect x="5" y="1" width="1" height="5.25" rx="0.2" fill="currentColor" />
      <rect x="3.25" y="6.25" width="1.5" height="8.5" rx="0.25" fill="currentColor" />
      <path
        fill="currentColor"
        d="M10.5 1.25h1.05l3.1 6v7.5h-1.05V8.35l-2.75 5.4h-1.05l2.85-5.55V1.25H10.5z"
      />
    </svg>
  );
}

/** Production footer lock / price tooltip icon (17×16) */
export function FooterLockIcon() {
  return (
    <svg
      className="booking-footer__lock-icon"
      viewBox="0 0 17 16"
      width={17}
      height={16}
      aria-hidden
      focusable="false"
    >
      <path
        fill="currentColor"
        d="M7.875 9.953a.626.626 0 0 0 1.25 0V8.937A2.505 2.505 0 0 0 11 6.516c0-1.38-1.121-2.5-2.5-2.5a2.503 2.503 0 0 0-2.5 2.5.625.625 0 0 0 1.25 0 1.251 1.251 0 0 1 2.5 0c0 .689-.56 1.25-1.25 1.25a.626.626 0 0 0-.625.624v1.563zM8.5 12.61a.78.78 0 1 0 0-1.562.78.78 0 0 0 0 1.562zm0-11.36c3.73 0 6.75 3.02 6.75 6.751 0 3.73-3.019 6.75-6.75 6.75A6.746 6.746 0 0 1 1.75 8 6.747 6.747 0 0 1 8.5 1.25zM8.5 16c4.422 0 8-3.577 8-7.999 0-4.421-3.578-8-8-8-4.422 0-8 3.578-8 8 0 4.421 3.578 8 8 8z"
      />
    </svg>
  );
}

export function BookingBaggageNote({ count }: { count: number }) {
  const [feesOpen, setFeesOpen] = useState(false);
  const n = Math.max(0, Math.min(9, Math.round(count)));

  return (
    <>
      <button
        type="button"
        className="booking-baggage-note"
        aria-haspopup="dialog"
        aria-expanded={feesOpen}
        onClick={() => setFeesOpen(true)}
      >
        <span className="booking-baggage-note__label">Baggage</span>:<span className="booking-baggage-note__value">
          {' '}
          <b>
            {n}
            <span className="booking-baggage-note__pcs">pcs</span>
          </b>
          {n > 0
            ? Array.from({ length: n }, (_, i) => <BaggageSuitcaseIcon key={i} />)
            : null}
        </span>
      </button>
      <BookingBaggageFeesModal open={feesOpen} onClose={() => setFeesOpen(false)} />
    </>
  );
}
